import { TotalValueOfGoodsModel } from "@/models/Cart";
import { DeliveryModel } from "@/models/deliveryModel";
import { ProductModel, Variant } from "../models/product";

class PreloadState implements IPreloadState {

    get product(): ProductModel {
        return this.state.product;
    }

    get deliveries(): DeliveryModel {
        return this.state.deliveries;
    }

    get totalValueOfGoods(): TotalValueOfGoodsModel {
        return this.state.totalValueOfGoods;
    }

    get state(): IPreloadState  {
        if (window.__finja) {
            return window.__finja.preloadstate;
        }

        return {
            product: { variants: Array<Variant>() } as ProductModel,
            deliveries: {} as DeliveryModel,
            totalValueOfGoods: {} as TotalValueOfGoodsModel
        };
    }
}

export interface IPreloadState {
    product: ProductModel;
    deliveries: DeliveryModel;
    totalValueOfGoods: TotalValueOfGoodsModel;
}

export default new PreloadState();
